/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HotWaterSourceEnum = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export const HotWaterSourceEnum = {
    NUMBER_1: 1 as HotWaterSourceEnum,
    NUMBER_2: 2 as HotWaterSourceEnum,
    NUMBER_3: 3 as HotWaterSourceEnum,
    NUMBER_4: 4 as HotWaterSourceEnum,
    NUMBER_5: 5 as HotWaterSourceEnum,
    NUMBER_6: 6 as HotWaterSourceEnum,
    NUMBER_7: 7 as HotWaterSourceEnum,
    NUMBER_8: 8 as HotWaterSourceEnum
};

